/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Client type
 * @export
 * @interface ClientType
 */
export interface ClientType {
    /**
     * 
     * @type {string}
     * @memberof ClientType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientType
     */
    value?: string;
}

/**
 * Check if a given object implements the ClientType interface.
 */
export function instanceOfClientType(value: object): value is ClientType {
    return true;
}

export function ClientTypeFromJSON(json: any): ClientType {
    return ClientTypeFromJSONTyped(json, false);
}

export function ClientTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientType {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function ClientTypeToJSON(json: any): ClientType {
    return ClientTypeToJSONTyped(json, false);
}

export function ClientTypeToJSONTyped(value?: ClientType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

